<template>
  <div class="xl:flex">
    <Nav class="w-full xl:w-1/6" />
    <div class="loyalty-programme-content text-left flex-1 w-full xl:w-5/6">

      <Spinner v-if="initLoading" />
      <template v-else>
        <table class="text-sm sm:text-base w-full overflow-x-auto">
          <thead>
            <tr class="border-none bg-gray-50">
              <th class="p-3">{{ $t('loyalty-programme.reward') }}</th>
              <th class="p-3">{{ $t('loyalty-programme.date') }}</th>
              <th class="p-3">{{ $t('loyalty-programme.code') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="border-t border-tables"
              v-for="rewardHistoryEntry in rewardHistoryEntries"
              :key="rewardHistoryEntry.id"
            >
              <td class="p-3">
                {{ rewardHistoryEntry.rewardName[$i18n.locale] }}
              </td>
              <td class="p-3">
                {{ formatDate(rewardHistoryEntry.date) }}
              </td>
              <td class="p-3">
                {{ rewardHistoryEntry.rewardCode }}
                <template v-if="rewardHistoryEntry.rewardUrl">
                  <a
                    :href="rewardHistoryEntry.rewardUrl"
                    target="_blank"
                    class="text-primary"
                  >
                    {{ $t('loyalty-programme.download') }}
                  </a>
                </template>
              </td>
            </tr>
            <tr class="border-t border-tables" v-if="rewardHistoryEntries.length === 0">
              <td colspan="3" class="p-3 text-center">
                {{ $t('loyalty-programme.empty-reward-history') }}
              </td>
            </tr>
          </tbody>
        </table>
      </template>

    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { LoyaltyHistoryEntry } from "@/models/loyaltyHistoryEntry";
import { useI18n } from "vue-i18n";
import axios from "axios";
import Spinner from "@/components/Spinner.vue";
import Nav from "@/pages/loyalty-programme/nav.vue";

const {d} = useI18n();

function formatDate(date: Date) {
  if (date instanceof Date) {
    return d(date);
  }
  return date;
}

async function fetchRewardHistoryEntries(): Promise<LoyaltyHistoryEntry[]> {
  const rewardHistoryEntriesResponse = await axios.get<LoyaltyHistoryEntry[]>(
    '/loyalty-programme/history-entries'
  );
  return rewardHistoryEntriesResponse.data;
}

const initLoading = ref(true);
const rewardHistoryEntries = ref<LoyaltyHistoryEntry[]>([]);
async function initialize() {
  rewardHistoryEntries.value = await fetchRewardHistoryEntries();
  initLoading.value = false;
}
initialize();

</script>
